export const UPGRADE_BULLET_PLAGIARIAM = 'upgrade-bullet-plagiarism'
export const UPGRADE_BULLET_STYLES = 'upgrade-bullet-styles'
export const UPGRADE_BULLET_GRAMMAR = 'upgrade-bullet-grammar'
export const UPGRADE_BULLET_INTEXT = 'upgrade-bullet-intext'
export const UPGRADE_BULLET_TRIAL = 'upgrade-bullet-trial'
export const UPGRADE_BULLET_UNLIM_REFS = 'upgrade-bullet-unlim-refs'
export const UPGRADE_BULLET_SAVEBIB = 'upgrade-bullet-savebib'
export const TC_LINK = 'tc-link'
